import React from "react";
import OnScreenKeyboard from "../Common/OnScreenKeyboard";
import ModalCloseButton from "../Common/ModalCloseButton";

const SearchModal = ({
  searchTerm,
  onSearchChange,
  onClose,
  resultsCount,
  isMobile
}) => {
  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("search-modal")) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onClose();
    }
  };

  const handleKeyboardPress = (button) => {
    if (button === "{enter}") {
      onClose();
    }
  };

  const clearSearch = () => {
    onSearchChange("");
  };

  return (
    <div className="search-modal" onClick={handleBackdropClick}>
      <div className="search-modal-content">
        <ModalCloseButton onClick={onClose} />
        <div className="search-input-container">
          <input
            type="text"
            placeholder="Search items..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
          />
          {!isMobile && (
            <OnScreenKeyboard
              isVisible={!isMobile}
              onChange={onSearchChange}
              onKeyPress={handleKeyboardPress}
            />
          )}
          {searchTerm.length > 0 && (
            <button className="clear-search-btn" onClick={clearSearch}>
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
        {searchTerm.length >= 2 && (
          <div className="search-results-count">
            {resultsCount} item{resultsCount !== 1 ? "s" : ""} found
          </div>
        )}
        {searchTerm.length <= 1 && (
          <div className="search-results-count">Search our inventory</div>
        )}
      </div>
    </div>
  );
};

export default SearchModal;
